import { render, staticRenderFns } from "./EditMoreFields.vue?vue&type=template&id=676704f2"
import script from "./EditMoreFields.vue?vue&type=script&lang=js"
export * from "./EditMoreFields.vue?vue&type=script&lang=js"
import style0 from "./EditMoreFields.vue?vue&type=style&index=0&id=676704f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports